import {AuthGuard} from '../../shared/guards/AuthGuard';
import {GraficosPresentation} from './components';
import {Sidebar} from '../../shared/components';

export const GraficosPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                {/* <GraficosPresentation/> */}
            </Sidebar>
        </AuthGuard>
    )
};